module.exports = __webpack_public_path__ + "img/thumb_28.68190451.jpg";